<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">

          <BackButton
              :label="$t('general.button.back')"
              :to="{ name: 'courseGroupCoachingList' }"
              marginBottom="5"/>

          <div class="d-flex justify-content-between">
            <h6 class="element-header">
              {{ $t('course.general_title') }}
            </h6>
          </div>

          <div class="element-box">
            <h5 class="form-header">
              {{ $t('course.group_coaching.title') }}
            </h5>

            <!--            <form v-if="isLoaded" @submit.prevent="submitForm" novalidate>-->
            <!--              <div class="row">-->
            <!--                <div class="col-lg-6 col-md-6 col-sm-12">-->
            <!--                  <BaseInput-->
            <!--                      v-model="formData.nameOfCoaching"-->
            <!--                      label="Bezeichnung"-->
            <!--                      :required=true-->
            <!--                      :validation="v$.nameOfCoaching"-->
            <!--                      :messages="v$.nameOfCoaching.required.$message">-->
            <!--                  </BaseInput>-->
            <!--                  <div v-if="operationTypeDropdown && operationTypeDropdown.length">-->
            <!--                    <SelectVue-->
            <!--                        v-model="formData.operationType"-->
            <!--                        :options="operationTypeDropdown"-->
            <!--                        :is-clear="true"-->
            <!--                        :required="true"-->
            <!--                        label="Maßnahmenart"-->
            <!--                        placeholder="Maßeinheitentyp auswählen"-->
            <!--                        :validation="v$.operationType"-->
            <!--                        :messages="v$.operationType.required.$message"/>-->
            <!--                  </div>-->
            <!--                  <BaseInput-->
            <!--                      v-model="formData.actionNumber"-->
            <!--                      label="Maßnahmennummer"-->
            <!--                      :required=true-->
            <!--                      :validation="v$.actionNumber"-->
            <!--                      :messages="v$.actionNumber.required.$message">-->
            <!--                  </BaseInput>-->
            <!--                  <div v-if="officeDropdown && officeDropdown.length">-->
            <!--                    <SelectVue-->
            <!--                        v-model="formData.officeId"-->
            <!--                        :options="officeDropdown"-->
            <!--                        :is-clear="true"-->
            <!--                        :required="true"-->
            <!--                        label="Standort"-->
            <!--                        :validation="v$.officeId"-->
            <!--                        :messages="v$.officeId.required.$message"/>-->
            <!--                  </div>-->
            <!--                  <div class="row mb-3">-->
            <!--                    <div class="col-lg-6 col-md-6 col-sm-12">-->
            <!--                      <Datepicker-->
            <!--                          v-model="formData.startDate"-->
            <!--                          :required="true"-->
            <!--                          label="Start"-->
            <!--                          :validation="v$.startDate"-->
            <!--                          :messages="v$.startDate.required.$message"/>-->
            <!--                    </div>-->
            <!--                    <div class="col-lg-6 col-md-6 col-sm-12">-->
            <!--                      <Datepicker-->
            <!--                          v-model="formData.endDate"-->
            <!--                          :required="true"-->
            <!--                          label="Ende"-->
            <!--                          :validation="v$.endDate"-->
            <!--                          :messages="v$.endDate.required.$message"/>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                  <div class="row mb-3">-->
            <!--                    <div class="col-lg-6 col-md-6 col-sm-12">-->
            <!--                      <BaseNumber-->
            <!--                          v-model="formData.units"-->
            <!--                          label="Einheiten (Gesamtanzahl) "-->
            <!--                          :required=true-->
            <!--                          :validation="v$.units"-->
            <!--                          :messages="v$.units.required.$message"/>-->
            <!--                    </div>-->
            <!--                    <div class="col-lg-6 col-md-6 col-sm-12">-->
            <!--                      <BaseNumber-->
            <!--                          v-model="formData.cost"-->
            <!--                          label="Umsatz pro Einheit"-->
            <!--                          :required=true-->
            <!--                          :isCurrency=true-->
            <!--                          :decimalPlaces="4"-->
            <!--                          :validation="v$.cost"-->
            <!--                          :messages="v$.cost.required.$message"/>-->
            <!--                    </div>-->

            <!--                    <div class="mb-3">-->
            <!--                      <BaseToggle-->
            <!--                          v-model="formData.taxExempt"-->
            <!--                          label="Umsatzsteuerbefreit"/>-->
            <!--                    </div>-->

            <!--                    <div class="row mb-3" v-if="!formData.taxExempt">-->
            <!--                      <div class="col-lg-6 col-md-6 col-sm-12">-->
            <!--                        <BaseNumber-->
            <!--                            v-model="formData.taxPercentage"-->
            <!--                            label="Steuersatz (%)"-->
            <!--                            :isReadOnly="true"-->
            <!--                            :disabled="true"/>-->
            <!--                      </div>-->
            <!--                      <div class="col-lg-6 col-md-6 col-sm-12">-->
            <!--                        <BaseNumber-->
            <!--                            v-model="formData.costWithTaxes"-->
            <!--                            label="Umsatz inkl. MwSt."-->
            <!--                            :isCurrency="true"-->
            <!--                            :decimalPlaces="4"-->
            <!--                            :isReadOnly="true"-->
            <!--                            :disabled="true"/>-->
            <!--                      </div>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                  <div v-if="clientDropdown && clientDropdown.length">-->
            <!--                    <SelectVue-->
            <!--                        v-model="formData.clientIds"-->
            <!--                        :options="clientDropdown"-->
            <!--                        :is-clear="true"-->
            <!--                        :is-multi="true"-->
            <!--                        :required="true"-->
            <!--                        :label="$t('placeholder.client_name')"-->
            <!--                        :validation="v$.clientIds"-->
            <!--                        :messages="v$.clientIds.required.$message"/>-->
            <!--                  </div>-->
            <!--                </div>-->

            <!--                <div class="col-lg-6 col-md-6 col-sm-12">-->
            <!--                  <div v-for="(coach, index) in formData.coaches" :key="index"-->
            <!--                       class="d-flex align-items-center mb-2">-->
            <!--                    <div class="flex-grow-1 me-2">-->
            <!--                      <SelectVue-->
            <!--                          v-model="coach.coachId"-->
            <!--                          :options="coachDropdown"-->
            <!--                          :is-clear="true"-->
            <!--                          :required="true"-->
            <!--                          label="Coach"-->
            <!--                          placeholder="Wählen Sie Coach"-->
            <!--                          :validation="v$.coaches?.$each?.$response?.$data[index]?.coachId"-->
            <!--                          :messages="v$.coaches?.$each?.$response?.$errors[index]?.coachId[0]?.$message"-->
            <!--                          @update:modelValue="onSelectCoach(coach.coachId, index)"/>-->

            <!--                      <div v-if="coach?.engagementType === 'extern'" class="row">-->
            <!--                        <div class="col-lg-6 col-md-12 col-sm-12">-->
            <!--                          <SelectVue-->
            <!--                              v-model="coach.billingType"-->
            <!--                              :options="coachBillingTypeDropdown"-->
            <!--                              :is-clear="true"-->
            <!--                              :required="true"-->
            <!--                              label="Abrechnungsart"-->
            <!--                              placeholder="Wählen Sie die Abrechnungsart"-->
            <!--                              :validation="v$.coaches.$each.$response.$data[index]?.billingType"-->
            <!--                              :messages="v$.coaches.$each.$response.$errors[index]?.billingType[0]?.$message"/>-->
            <!--                        </div>-->
            <!--                        <div class="col-lg-6 col-md-12 col-sm-12">-->
            <!--                          <BaseNumber-->
            <!--                              v-model="coach.cost"-->
            <!--                              label="Kosten"-->
            <!--                              :decimalPlaces="2"-->
            <!--                              :required=true-->
            <!--                              :validation="v$.coaches.$each.$response.$data[index]?.cost"-->
            <!--                              :messages="v$.coaches.$each.$response.$errors[index]?.cost[0]?.$message"/>-->
            <!--                        </div>-->
            <!--                      </div>-->
            <!--                    </div>-->

            <!--                    <button class="btn btn-danger ms-2"-->
            <!--                            @click="deleteCoach(index)">-->
            <!--                      <i class="os-icon os-icon-trash"></i>-->
            <!--                    </button>-->
            <!--                  </div>-->

            <!--                  <div class="text-center mt-3">-->
            <!--                    <button type="button" class="btn btn-primary" @click="addCoach">Coach hinzufügen</button>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--              <div class="form-buttons-w text-center">-->
            <!--                <button class="btn btn-primary" type="submit">{{ $t('general.button.save') }}</button>-->
            <!--              </div>-->
            <!--            </form>-->

            <form v-if="isLoaded" @submit.prevent="submitForm" novalidate class="form-styled">
              <div class="row">
                <div class="col-12">
                  <AuditInfo
                      :user-role="currentUserRole"
                      :created-by-user-data="formData.createdByUserData"
                      :created-at="formData.createdAt"
                      :updated-by-user-data="formData.updatedByUserData"
                      :updated-at="formData.updatedAt"/>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-7 col-md-12">

                  <div class="form-section shadow-sm mb-4">
                    <h6 class="section-title">Allgemeine Informationen</h6>
                    <div class="row">
                      <div class="col-12">
                        <BaseInput
                            v-model="formData.nameOfCoaching"
                            label="Bezeichnung" :required="true"
                            :validation="v$.nameOfCoaching"
                            :messages="v$.nameOfCoaching.required.$message"/>
                      </div>
                      <div class="col-md-6">
                        <SelectVue
                            v-if="operationTypeDropdown?.length"
                            v-model="formData.operationType"
                            :options="operationTypeDropdown"
                            label="Maßnahmenart" :required="true"
                            :validation="v$.operationType"
                            :messages="v$.operationType.required.$message"/>
                      </div>
                      <div class="col-md-6">
                        <BaseInput
                            v-model="formData.actionNumber"
                            label="Maßnahmennummer"
                            :required="true"
                            :validation="v$.actionNumber"
                            :messages="v$.actionNumber.required.$message"/>
                      </div>
                      <div class="col-12">
                        <SelectVue
                            v-if="officeDropdown?.length"
                            v-model="formData.officeId"
                            :options="officeDropdown"
                            label="Standort"
                            :required="true"
                            :validation="v$.officeId"
                            :messages="v$.officeId.required.$message"/>
                      </div>
                    </div>
                  </div>

                  <div class="form-section shadow-sm mb-4 bg-light-blue">
                    <h6 class="section-title">Zeitraum & Finanzen</h6>
                    <div class="row">
                      <div class="col-md-6">
                        <Datepicker
                            v-model="formData.startDate"
                            label="Start"
                            :required="true"
                            :validation="v$.startDate"
                            :messages="v$.startDate.required.$message"/>
                      </div>
                      <div class="col-md-6">
                        <Datepicker
                            v-model="formData.endDate"
                            label="Ende"
                            :required="true"
                            :validation="v$.endDate"
                            :messages="v$.endDate.required.$message"/>
                      </div>

                      <div class="col-md-6 mt-3">
                        <BaseNumber
                            v-model="formData.units"
                            label="Einheiten (Gesamt)" :required="true"
                            :validation="v$.units"
                            :messages="v$.units.required.$message"/>
                      </div>
                      <div class="col-md-6 mt-3">
                        <BaseNumber
                            v-model="formData.cost"
                            label="Preis exkl. USt"
                            :isCurrency="true"
                            :decimalPlaces="4"
                            :required="true"
                            :validation="v$.cost"
                            :messages="v$.cost.required.$message"/>
                      </div>

                      <div class="col-12 mt-3">
                        <div class="d-flex align-items-center">
                          <BaseToggle
                              v-model="formData.taxExempt"
                              label="Umsatzsteuerbefreit"/>
                          <small class="text-muted ms-3">
                            ({{
                              formData.taxExempt ? 'Steuerfrei (Umsatzsteuer exkludiert)' : 'Steuerpflichtig (Umsatzsteuer inkludiert)'
                            }})
                          </small>
                        </div>
                      </div>

                      <div class="col-12 mt-3" v-if="!formData.taxExempt">
                        <div class="row">
                          <div class="col-md-6">
                            <BaseNumber
                                v-model="formData.taxPercentage"
                                label="USt (%)"
                                :disabled="true"/>
                          </div>
                          <div class="col-md-6">
                            <BaseNumber
                                v-model="formData.costWithTaxes"
                                label="Preis inkl. USt."
                                :isCurrency="true"
                                :decimalPlaces="4"
                                :disabled="true"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-section shadow-sm">
                    <h6 class="section-title">Teilnehmer</h6>
                    <SelectVue
                        v-if="clientDropdown?.length"
                        v-model="formData.clientIds"
                        :options="clientDropdown"
                        :is-multi="true"
                        :required="true"
                        :label="$t('placeholder.client_name')"
                        :validation="v$.clientIds"
                        :messages="v$.clientIds.required.$message"/>
                  </div>
                </div>

                <div class="col-lg-5 col-md-12 mt-4 mt-lg-0">
                  <div class="form-section shadow-sm h-100">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <h6 class="section-title mb-0">Zugeordnete Coaches</h6>
                    </div>

                    <div v-for="(coach, index) in formData.coaches" :key="index"
                         class="coach-card mb-3 p-3 border rounded shadow-sm">
                      <div class="d-flex justify-content-between align-items-start mb-2">
                        <div class="flex-grow-1">
                          <SelectVue
                              v-model="coach.coachId"
                              :options="coachDropdown"
                              label="Coach"
                              placeholder="Coach wählen"
                              :validation="v$.coaches?.$each?.$response?.$data[index]?.coachId"
                              :messages="v$.coaches?.$each?.$response?.$errors[index]?.coachId[0]?.$message"
                              @update:modelValue="onSelectCoach(coach.coachId, index)"/>
                        </div>
                        <button class="btn btn-link text-danger p-0 ms-2" @click="deleteCoach(index)">
                          <i class="os-icon os-icon-trash" style="font-size: 1.3rem;"></i>
                        </button>
                      </div>

                      <div v-if="coach?.engagementType === 'extern'" class="mt-3">
                        <div class="row gx-2 gy-3">
                          <div class="col-12 col-xxl-6">
                            <SelectVue
                                v-model="coach.billingType"
                                :options="coachBillingTypeDropdown"
                                :is-clear="true"
                                :required="true"
                                label="Abrechnungsart"
                                placeholder="Wählen..."
                                :validation="v$.coaches.$each.$response.$data[index]?.billingType"
                                :messages="v$.coaches.$each.$response.$errors[index]?.billingType[0]?.$message"/>
                          </div>
                          <div class="col-12 col-xxl-6">
                            <BaseNumber
                                v-model="coach.cost"
                                label="Kosten"
                                :decimalPlaces="2"
                                :required="true"
                                :isCurrency="true"
                                :validation="v$.coaches.$each.$response.$data[index]?.cost"
                                :messages="v$.coaches.$each.$response.$errors[index]?.cost[0]?.$message"/>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="text-center mt-3 mb-3">
                      <button type="button" class="btn btn-outline-primary btn-sm" @click="addCoach">
                        <i class="os-icon os-icon-plus"></i> Hinzufügen
                      </button>
                    </div>

                    <div v-if="!formData.coaches.length" class="text-center text-muted p-5">
                      <i class="os-icon os-icon-user-check d-block mb-2" style="font-size: 2rem;"></i>
                      Keine Coaches zugewiesen
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-buttons-w text-center">
                <SaveButton
                    :label="$t('general.button.save')"
                    :loading="isSubmitting"/>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Sidebar></Sidebar>
    </div>
  </div>
</template>

<script setup lang="ts">
import courseGroupCoachingService from '@/api/Course/GroupCoaching';
import AuditInfo from '@/components/AuditInfo.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import CreateButton from '@/components/CreateButton.vue';
import Sidebar from '@/components/FormSidebar.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import {ErrorToast, SuccessToast} from '@/components/VueToast';
import router from '@/router';
// @ts-ignore
import {getClientDropdown, getOfficeDropdown, getUserDropdown} from '@/shared/dropdowns';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import useVuelidate from '@vuelidate/core';
import {helpers} from '@vuelidate/validators';
import 'daterangepicker';
import 'daterangepicker/daterangepicker.css';
import {computed, onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import {ICourseGroupCoaching} from "@/interfaces/Course/GroupCoaching/ICourseGroupCoaching";
import BaseToggle from "@/components/base/BaseToggle.vue";
import BackButton from "@/components/button/BackButton.vue";
import SaveButton from "@/components/button/SaveButton.vue";

const {t} = useI18n();
const piniaUserState = piniaUserStore();
const currentUserRole = computed(() => piniaUserState.currentUser?.user?.roles?.[0]);
const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const operationTypeDropdown = ref([]);
const officeDropdown = ref([]);
const clientDropdown = ref([]);
const coachDropdown = ref([]);
const coachBillingTypeDropdown = ref([]);
const isSubmitting = ref(false);
const isLoaded = ref(false);
const route = useRoute();
const courseId = route.params.id;

const formData = ref<ICourseGroupCoaching>({
  nameOfCoaching: '',
  operationType: '',
  actionNumber: '',
  startDate: '',
  endDate: '',
  units: null,
  cost: null,
  taxExempt: true,
  costWithTaxes: null,
  taxPercentage: null,
  officeId: null,
  clientIds: [],
  coaches: [],
});

const rules = ref({
  nameOfCoaching: requiredRule(t),
  operationType: requiredRule(t),
  actionNumber: requiredRule(t),
  startDate: requiredRule(t),
  endDate: requiredRule(t),
  units: requiredRule(t),
  cost: requiredRule(t),
  officeId: requiredRule(t),
  clientIds: requiredRule(t),
  coaches: {
    $each: helpers.forEach({
      coachId: requiredRule(t),
      billingType: requiredRule(t),
      cost: requiredRule(t),
    }),
  },
});


watch(
    [() => formData.value.taxExempt, () => formData.value.cost],
    ([isExempt, newCost]) => {
      if (isExempt) {
        formData.value.taxPercentage = 0;
        formData.value.costWithTaxes = newCost;
      } else {
        formData.value.taxPercentage = 19;
        if (newCost) {
          const total = Number(newCost) * 1.19;
          formData.value.costWithTaxes = Number(total.toFixed(4));
        } else {
          formData.value.costWithTaxes = null;
        }
      }
    },
    {immediate: true}
);

const computedRules = computed(() => rules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    if (courseId) {
      await courseGroupCoachingService.putCourse(formData.value, +courseId);
    } else {
      await courseGroupCoachingService.postCourse(formData.value);
    }

    await router.push({name: 'courseGroupCoachingList'});
    isSubmitting.value = false;

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getCourse() {
  try {
    const {data} = await courseGroupCoachingService.getCourse(+courseId);
    const officeId = data.data.location.id;
    const clients = data.data.clients || [];
    const clientArray = clients
        .map((client: any) => client?.id)
        .filter((id: number | null) => id != null);
    const coaches = data.data.coaches || [];
    const coachesArray = coaches.map((item: any) => ({
      coachId: item.id,
      engagementType: item.engagementType,
      billingType: item.billingType !== null ? item.billingType : 'null',
      cost: item.cost !== null ? item.cost : 0,
    }));

    formData.value = {...data.data, clientIds: clientArray, officeId: officeId, coaches: coachesArray};
  } catch (error) {
    await ErrorToast(error);
  }
}

async function addCoach() {
  formData.value.coaches.push({coachId: '', billingType: '', cost: '', engagementType: ''});
  v$.value.$touch();
}

async function deleteCoach(index: number) {
  formData.value.coaches.splice(index, 1);
}

async function onSelectCoach(coachId: string | number, index: number) {
  try {
    if (coachId !== undefined && coachId !== '' && coachId !== null) {
      const coach = (coachDropdown.value as any[]).find((item: any) => item.value === +coachId);

      formData.value.coaches[index].engagementType = coach?.engagementType;

      if (coach?.engagementType === 'intern') {
        formData.value.coaches[index].billingType = 'null';
        formData.value.coaches[index].cost = 0;
      }
    } else {
      await deleteCoach(index);
    }

  } catch (error) {
    await ErrorToast(error);
  }
}

async function getCourseGroupCoachingEnumDropdowns() {
  operationTypeDropdown.value = getEnums?.value?.groupCoachingOperationTypes || [];
  coachBillingTypeDropdown.value = getEnums?.value?.coachBillingTypes || [];
}

onMounted(async () => {
  //if (Object.keys(getEnums.value).length === 0) {
  //  await store.dispatch('getEnums', { t });
  //}

  await Promise.all([
    getCourseGroupCoachingEnumDropdowns(),
    getUserDropdown(coachDropdown),
    getOfficeDropdown(officeDropdown),
    getClientDropdown(clientDropdown),
  ]);

  if (courseId) {
    await getCourse();
  }

  isLoaded.value = true;
});

</script>

<style scoped>
@media (max-width: 1700px) {
  .bg-light.rounded.border {
    padding: 10px !important;
  }
}
</style>